import React, { useState, useRef, useEffect } from "react";
import { PlacesType } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import CustomBrandTooltip from "./CustomBrandTooltip";
import useBreakpoint from "../../hooks/useBreakpoint";

interface TooltipProps {
  id: string | undefined;
  children: React.ReactElement;
  place?: PlacesType;
  tooltip: React.ReactNode;
  className?: string;
  tooltipClassnames?: string;
  handleClick?: (e: any) => void;
}

const BrandTooltip: React.FC<TooltipProps> = (props) => {
  const { children, place, tooltip, id, className, handleClick } = props;
  const [isVisible, setIsVisible] = useState(false);
  const { isMobile } = useBreakpoint();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const showTooltip = () => {
    setIsVisible(true);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const hideTooltip = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setIsVisible(false);
    }, 200);
  };

  const handleMouseEnter = () => {
    if (!isMobile) {
      showTooltip();
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      hideTooltip();
    }
  };

  const handleTouchStart = () => {
    if (isMobile) {
      showTooltip();
    }
  };

  const handleTouchEnd = () => {
    if (isMobile) {
      hideTooltip();
    }
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      className={`flex ${className} break-words`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onClick={handleClick}
    >
      {children &&
        React.cloneElement(children, {
          "data-tooltip-id": id,
          ...(typeof tooltip === 'string' ? { 'data-tooltip-content': tooltip } : {})
        })}
      {id && (
        <CustomBrandTooltip
          tooltipClassnames={props.tooltipClassnames}
          id={id}
          isOpen={isVisible}
          place={place}
        >
          {typeof tooltip !== 'string' ? tooltip : null}
        </CustomBrandTooltip>
      )}
    </div>
  );
};

export default React.memo(BrandTooltip);
